import React, {useEffect, useState} from 'react';
import { Modal } from './Modal';
import { GeneralModal as ModalContextProvider } from '../../hooks/Context';
import { TopDisplay, FilterDropDown, option1b, DateFilter, Events } from '../../ui-components';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { MdOutlineBusinessCenter as ExecoIcons,MdWorkOff as PratIcon, MdMilitaryTech as MiliIcons, MdCorporateFare as CorpIcons,MdOutgoingMail as OngoIcons} from 'react-icons/md';
import {BsArrowRight as RightArrow} from "react-icons/bs";
import {HiAcademicCap,HiAcademicCap as AcadIcons} from "react-icons/hi";
import { FetchSingleData } from '../../hooks/FetchData';
import Charts from './Charts';
import { useQuery } from '@tanstack/react-query';
import apiCall from '../../utils/apiCall';
import { GrStatusGood as CompletedIcon } from 'react-icons/gr';
import { MdOutgoingMail as OngoingIcon } from 'react-icons/md';
import { MdIncompleteCircle as IncompleteIcon } from 'react-icons/md';
import { MdCancelScheduleSend as RejectedIcon } from 'react-icons/md';
import { MdMilitaryTech as MilitaryIcon } from 'react-icons/md';
import { IoIosSchool as ExamIcon } from 'react-icons/io';
import { MdCorporateFare as PractitionerIcon } from 'react-icons/md';
import { HiAcademicCap as AcademicIcon } from 'react-icons/hi';

// const eventArr = [
//     {date:"2023-09-25 12:45:00",name:"Training"},
//     {date:"2023-09-24 12:45:00",name:"Training"},
//     {date:"2023-09-23 12:45:00",name:"Training"},
//     {date:"2023-09-25 12:45:00",name:"Training"},
//     {date:"2023-09-24 12:45:00",name:"Training"},
//     {date:"2023-09-23 12:45:00",name:"Training"},
//     {date:"2023-09-25 12:45:00",name:"Training"},
//     {date:"2023-09-24 12:45:00",name:"Training"},
//     {date:"2023-09-23 12:45:00",name:"Induction"}
//   ]
let eventArr:any;

const RouteFilter = () =>{
    const routeOptions = option1b('');
    const [route,setRoute] = useState<any>(null);
    return (
        <FilterDropDown text="Membership Route" options={routeOptions}      
        onChange={setRoute} border="white" bg="#F2F2F2"
         />
    )
}

const initial_data = [
    {name:"Jan",value:12},
    {name:"Feb",value:25},
    {name:"Mar",value:32},
    {name:"Apr",value:20},
    {name:"May",value:0},
    {name:"Jun",value:25},
    {name:"Jul",value:32},
    {name:"Aug",value:0},
    {name:"Sep",value:12},
    {name:"Oct",value:25},
    {name:"Nov",value:32},
    {name:"Dec",value:20},
]

const Overview2 = (props:any) => {
    const userHasChangePassword = props.data;
    const setUserHasChangePassword = props.onChange;
    const formatChartData = (data:any) =>{
        let arr:any = Array.from(initial_data);
        let temp_arr:any = [];
        let year = (new Date()).getFullYear();
        arr.forEach((eArr:any,index:number)=>{
            let month = index;
            let check = data.find((eData:any)=>{
                return eData.RegistrationYear == year && eData.RegistrationMonth == month+1
            })
            if(check){
                temp_arr.push({
                    name:`${arr[month].name}`,
                    value:check.ApplicantCount
                })
            }else{
                temp_arr.push({
                    name:`${arr[month].name}`,
                    value:0
                })
            }
        })
        return [...temp_arr];
    }
    const [chart_data,set_chart_data] = useState<any>(null);
    const {data:temp_data,isLoading:data_loading} = FetchSingleData('chart-data','api/Applicant/GetAllApplicantChart','GET');

    const getTraining = async (): Promise<any> => {
        return (await apiCall().get('/SetUp/GetAllTraining')).data?.Data;
      };
      // induction here
    //   const getInduction = async (): Promise<any> => {
    //     return (await apiCall().get('/SetUp/GetAllInduction')).data?.Data;
    //   };
      const getDateNumber = (date:any)=>{
        let num = new Date(date).toISOString();
        return num

      }
    
      const {data:eventData, isLoading} = useQuery(['all-training'], getTraining, {
        retry: 0,
        keepPreviousData: true,
        enabled: true,
        select(data:any) {
            let newData =  data.sort((a:any,b:any)=> {
                getDateNumber(a.TrainingDate);
                return getDateNumber(b.TrainingDate) > getDateNumber(a.TrainingDate)?1:-1} ).map((eEvent:any) => ({
                date:eEvent.TrainingDate,
                name:eEvent.TrainingName,
            }));

            return newData;
        },
      });
      eventArr = eventData || [];

    useEffect(()=>{
        if(!data_loading &&  temp_data && temp_data?.Data && temp_data?.Data.length > 0){
            set_chart_data(formatChartData(temp_data?.Data))
        }

    },[temp_data,data_loading]);
    useEffect(()=>{

    },[chart_data])
  
  return (
    <ModalContextProvider>
        <Wrapper>
            <TopDisplay subTitle="All" title="Overview"
             Btn={<BtnWrapper><RouteFilter />
             <DateFilter />
            </BtnWrapper>}
            />
            <MidView />
            <LastWrapper>
                <div>
                    <div>Total Applicants</div>
                   { chart_data ?<Charts data={chart_data} />: 'Chart Loading...'}
                </div>
                
                <div >
                    <h3 style={{margin:'0'}}>Upcoming events</h3>
                    <div>
                    {eventArr.slice(0,3).reverse().map((eEvent:any,index:any)=>
                        <Events key={index} date={eEvent.date} name={eEvent.name} index={index} />
                    )}
                    </div>
                    <LinkWrapper to="/dashboard/settings/training" >
                    View more Events
                    <span><RightArrow /></span>
                    </LinkWrapper>

                </div>
            </LastWrapper>
        </Wrapper>
        <Modal data={{ userHasChangePassword, setUserHasChangePassword }} />
    </ModalContextProvider>
    
  )
}

export default Overview2;

export const MidView = (props:any) =>{
    const {data:applicantOverview} = FetchSingleData('appCount','api/Applicant/GetCountApplicantStatus')
    const {data:routeOverview} = FetchSingleData('routeCount','api/Applicant/GetCountApplicantRoute','POST')
    let {Data:appData} = applicantOverview?applicantOverview:{
        Data:{
            Completed:'0',
            Incomplete:'0',
            Ongoing:'0',
            Rejected:'0'
        }
    }
    
    let {Data: routeCount} = routeOverview ? routeOverview : {
        Data:{
            "ExaminationRoute": '0',
            "PractitionerRoute": '0',
            "ExecutiveRoute": '0',
            "AcademicRoute": '0',
            "MilitaryRoute": '0',
            "CorporateRoute": '0'
        }
    }
    return(
        <MidWrapper>
            <EachDiv cols={2} title="Applicants Overview">
                <EachItem color="#00AAFF" bg="#E1F5FE"
                    img={<IncompleteIcon/>} 
                label="Incomplete" value={appData.Incomplete || '0'} />
                <EachItem label="Ongoing" value={appData.Ongoing || '0'}
                    img={<OngoingIcon />}
                    bg="#FFF4DE" color="#FEB930"
                />
                <EachItem label="Rejected" value={appData.Rejected || '0'} 
                    img={<RejectedIcon />}
                    bg="#FFF1EE" color="#EB7D86"
                />
                <EachItem label="Completed" value={appData.Completed || '0'}
                    img={<CompletedIcon />}
                    bg="#E7F2E6" color="#3C9D34"
                 />
            </EachDiv>
            <EachDiv cols={3} title="Membership Overview (Route)">
                <EachItem color="#B54DF8" bg="#F6EAFE"
                    img={<ExamIcon/>} 
                label="Examination / NYSC" value={routeCount.ExaminationRoute} />
                <EachItem label="Practitioner" value={routeCount.PractitionerRoute}
                    img={<PratIcon />}
                    bg="#FFF4DE" color="#391651"
                />
                <EachItem label="Executive" value={routeCount.ExecutiveRoute} 
                    img={<PractitionerIcon />}
                    bg="#FFF1EE" color="#B54DF8"
                />
                <EachItem label="Academic" value={routeCount.AcademicRoute}
                    img={<AcademicIcon />}
                    bg="#E7F2E6" color="#3C9D34"
                 />
                  <EachItem label="Military" value={routeCount.MilitaryRoute} 
                    img={<MilitaryIcon />}
                    bg="#FFF1EE" color="#FF9271"
                />
                <EachItem label="Corporate" value={routeCount.CorporateRoute}
                    img={<PractitionerIcon />}
                    bg="#E7F2E6" color="#3C9D34"
                 />
            </EachDiv>
            {/* <EachDiv cols={2} title="Applicants Overview">
                <EachItem color="#00AAFF" bg="#E1F5FE"
                    img={<IncompleteIcon/>} 
                label="Incomplete" value="62,473" />
                <EachItem label="Ongoing" value="62,473"
                    img={<OngoingIcon/>}
                    bg="#FFF4DE" color="#FEB930"
                />
                <EachItem label="Rejected" value="62,473" 
                    img={<RejectedIcon />}
                    bg="#FFF1EE" color="#FF9271"
                />
                <EachItem label="Completed" value="62,473"
                    img={<CompletedIcon />}
                    bg="#E7F2E6" color="#3C9D34"
                 />
            </EachDiv> */}
            
        </MidWrapper>
    )
}

const LinkWrapper = styled(Link)`
display: flex;
background-color: #DCF9EB;
width: 100%;
justify-content: center;
align-items: center;
padding: 7px 0;
gap:10px;
border-radius: 5px;
text-decoration: none;
color:var(--text-green)
`

const MidWrapper = styled.div`
    width:100%;
    position:relative;
    min-height:250px;
    display: flex;
    gap:30px;
    margin-top:25px;

`

const Wrapper = styled.div`
    padding:0 20px 20px;
`

const EachDiv = (props:any) =>{
    const children = props.children;
    const title = props.title ? props.title : '';
    const cols = props.cols;
    return (<EachWrapper >
        <div>{title}</div>
        <div style={{gridTemplateColumns:`repeat(${cols},1fr)`}}>
           {children} 
        </div>
        
    </EachWrapper>)
}

const InnerDiv = (props:any) =>{
    const children = props.children;

    return (<div {...props}>
        {children}
    </div>)
}

const EachWrapper = styled.div`
    width: fit-content;
    display:flex;
    flex-direction: column;
    gap:25px;
    height:100%;
    border:1px solid #ddd;
    border-radius:8px;
    flex-shrink: 0;
    min-height:190px;
    padding: 15px;
    & > div:first-of-type{
        font-weight:bold;
    }
    & > div:nth-of-type(2){
        display: grid;
        gap:10px;
    }
`

const EachItem = (props:any) =>{
    const img = props.img;
    const label = props.label;
    const value = props.value;
    return(
        <EachStyedItem {...props}>
            <span>
                {/* <img src="" alt="Icon" /> */}
                {img}
            </span>
            <div>
                <span>{label || 'Label'}</span>
                <span>{value || 'Value'}</span>
            </div>
        </EachStyedItem>
    )
}

const EachStyedItem = styled(InnerDiv)`
    display:flex;
    gap: 10px;
    min-width:fit-content;
    align-items:center;
    & > span{
        width:48px;
        height:48px;
        display: flex;
        justify-content:center;
        align-items:center;
        border-radius: 5px;
        background-color:${props  => props.bg?props.bg:'#f2f2f2'};
        color:${props => props.color?props.color:'#222'};
        font-size:30px;
    }
    & > div{
        flex:1;
        display:flex;
        flex-direction:column;
        gap:2px;
    }
    & > div > span:nth-of-type(2){
        font-size:18px;
        font-weight: bold;
    }
`

export const BtnWrapper = styled.div`
    display: flex;
    gap:20px;
    align-items:center;
`

export const LastWrapper = styled.div`
    display:flex;
    align-items: flex-start;

    gap:20px;
    width:100%;
    & > div{
        padding:20px;
        border-radius: 10px;
        border:1px solid #E1E1E1;
        height:fit-content;
    }
    & > div:nth-of-type(2){
        width:250px;
    }
    & > div:first-of-type{
        width:calc(100% - 270px);
        display: flex;
        flex-direction: column;
        gap:20px;

    }
    & > div:first-of-type> div:first-of-type{
        font-weight:bold;
        font-size:20px;
    }
    & > div:first-of-type > div:nth-of-type(2){
        width:100%;
        min-height:300px;
    }
`


